import { render, staticRenderFns } from "./detailMaterial.vue?vue&type=template&id=3a4bb6fc"
import script from "./detailMaterial.vue?vue&type=script&lang=js"
export * from "./detailMaterial.vue?vue&type=script&lang=js"
import style0 from "./detailMaterial.vue?vue&type=style&index=0&id=3a4bb6fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports